import { vslApi } from '@/api';

export default {
  getVoyageList(params) {
    return vslApi.get('v1/voyages', {
      params: params,
    });
  },
};
